"use strict";

// Class definition
var KTFeedbackFormQr = function () {
    var submitButton;
    var form;
    var validator;
    var is_submit=false;

    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toastr-top-center",
        "preventDuplicates": true,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
      };


    // Define shared variables
    const handleBeforeUnload = (e) => {
        e.preventDefault();

        console.log("Submit : " + is_submit);

        if(!is_submit){
            const message = "Are you sure you want to leave? All provided data will be lost.";
            e.returnValue = message;
            return message;
        }else
            return true;

    };

    // Handle form
    var handleForm  = function(e) {
        const locationField = document.querySelector('[name="online_location_id"]');

        // Init form validation rules. For more info check the FormValidation plugin's official documentation:https://formvalidation.io/
        validator = FormValidation.formValidation(
			form,
			{
				fields: {
					'name': {
						validators: {
							notEmpty: {
								message: 'Name is required'
							}
						}
                    },
                    'company_name': {
						validators: {
							notEmpty: {
								message: 'Company name is required'
							}
						}
                    },
                    'designation': {
                        validators: {
                            notEmpty: {
                                message: 'Designation is required'
                            }
                        }
                    },
					'email': {
                        validators: {
                            regexp: {
                                regexp: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                message: 'The value is not a valid email address',
                            },
							notEmpty: {
								message: 'Email address is required'
							}
						}
					},
                    'phone_no': {
                        validators: {
                            notEmpty: {
                                message: 'Phone is required'
                            }
                        }
                    },
                    'feedback_type_id': {
                        validators: {
                            notEmpty: {
                                message: 'Feedback Type is required'
                            }
                        }
                    },
                    'online_location_id': {
                        validators: {
                            callback: {
                                message: 'Location is required',
                                callback: function (input) {
                                    // Get the selected options
                                    const options = locationField.val();
                                    return options != null && options.length >= 1;
                                },
                            },
                        },
                    },
                    'other_location': {
                        validators: {                            
                            callback: {
                                message: 'Please specify other location!.',
                                callback: function(input) {
                                    const selectedLocation = form.querySelector('[name="online_location_id"]');
                                    const framework = selectedLocation ? selectedLocation.text : '';

                                    return (framework !== 'Other') ? true : (input.value !== '');
                                }
                            }
                        }
                    },
                    'client_feedback': {
                        validators: {
                            notEmpty: {
                                message: 'Client Feedback is required'
                            }
                        }
                    },
                    // 'file': {
                    //     validators: {
                    //         file: {
                    //             extension: 'pdf,jpeg,jpg,png,wbmp,webp,doc,docx',
                    //             type: 'application/pdf,application/msword,image/jpeg,image/png,image/vnd.wap.wbmp,image/vnd.wap.wbmp',
                    //             message: 'Please choose a valid file(jpeg, png, pdf, doc.docx) or file size < 10Mb',
                    //             maxSize: 10485760
                    //         },
                    //     },
                    // },
				},
				plugins: {
                    trigger: new FormValidation.plugins.Trigger(),
					bootstrap: new FormValidation.plugins.Bootstrap5({
                        rowSelector: '.fv-row',
                        eleInvalidClass: '',  // comment to enable invalid state icons
                        eleValidClass: '' // comment to enable valid state icons
                    })
				}
			}
		);


        // Handle form submit
        submitButton.addEventListener('click', function (e) {
            e.preventDefault();
            validator.validate().then(function(status) {
		        if (status == 'Valid') {
                    // Show loading indication
                    submitButton.setAttribute('data-kt-indicator', 'on');

                    // Disable button to avoid multiple click 
                    submitButton.disabled = true;

                    // Hide loading indication
                    submitButton.removeAttribute('data-kt-indicator');
                    // Enable button
                    submitButton.disabled = false;

                    toastr.info("Your feedback is submitted.", "Info");

                    is_submit = true;
                    pageLoading();
                    form.submit();
                    //form.reset();  // reset 
					
                } else {                    
                    toastr.error("Sorry, please fill in all required fields!", "Error!");

                }
		    });

            function pageLoading(){
                const loadingEl = document.createElement("div");
                document.body.prepend(loadingEl);
                loadingEl.classList.add("page-loader");
                loadingEl.classList.add("flex-column");
                loadingEl.innerHTML = `
                    <span class="spinner-border text-primary" role="status"></span>
                    <span class="text-muted fs-6 fw-semibold mt-5">Loading...</span>
                `;

                // Show page loading
                KTApp.showPageLoading();

                // Hide after 3 seconds
                setTimeout(function () {
                        KTApp.hidePageLoading();
                        loadingEl.remove();
                    }, 3000);
                }
        });



    }
      
    // Define template element variables
    // Init dropzone
    const initDropzone = () => {
        const id = "#kt_upload_dropzone";
        console.log("upload-file");
        const dropzone = document.querySelector(id);
        const uploaded_uuid = [];

        var previewNode = dropzone.querySelector(".dropzone-item");
        previewNode.id = "";
        var previewTemplate = previewNode.parentNode.innerHTML;
        previewNode.parentNode.removeChild(previewNode);
        const token = $('meta[name="csrf-token"]').attr('content');

        var myDropzone = new Dropzone(id, {
                            url: "api/documents", // Set the url for your upload script location
                            paramName: "file", // The name that will be used to transfer the file
                            params: {
                                'token': document.querySelector('[name="ulid_session"]').value,
                                '_token': token,
                                'flag': 'F',
                            },
                            headers: {
                                'X-CSRF-TOKEN': token
                            },
                            maxFiles: 5,
                            acceptedFiles: ".jpeg,.jpg,.png,.gif,.pdf,.docx,.doc,.odt,.txt",
                            // addRemoveLinks: true,
                            timeout: 5000,
                            parallelUploads: 20,
                            maxFilesize: 5, // Max filesize in MB
                            previewTemplate: previewTemplate,
                            previewsContainer: id + " .dropzone-items", // Define the container to display the previews
                            clickable: id + " .dropzone-select", // Define the element that should be used as click trigger to select files.
                            success: function(file, response) 
                            {
                                var file_uuid = file.upload.uuid
                                if(response.success){
                                    toastr.success(response.message, "Success");
                                    uploaded_uuid[file_uuid] = response.data.id
                                }                                    
                            },
                            error: function(file, response)
                            {
                                // this.removeFile(file);
                                file.previewElement.remove();
                                console.log(response);
                                toastr.error(response, "Error!");

                               return false;
                            },
                            removedfile: function (file) {
                                var x = confirm('Are you sure want to delete this file?');
                                if (!x) 
                                    return false;
                                else{
                                var get_uuid = file.upload.uuid;
                                var get_id = uploaded_uuid[get_uuid];

                                const formData = new FormData();
                                formData.append("ulid", document.querySelector('[name="ulid_session"]').value);
                                formData.append("_token", token);  
                                formData.append("_method", "PATCH");  
                                

                                let result = KTAjax.get(token, formData, "POST", 'api/documents/'+ get_id);

                                result.then(response => {
                                    if (response.success) {  
                                        toastr.info(response.message, "Success");
                                        file.previewElement.remove();
                                    } 
                                    else
                                        toastr.error(response.message, "Error!");
                                }); 
                                
                                }


                            }
                        });

        myDropzone.on("addedfile", function (file) {
                            // Hookup the start button
                            const dropzoneItems = dropzone.querySelectorAll('.dropzone-item');
                            dropzoneItems.forEach(dropzoneItem => {
                                dropzoneItem.style.display = '';
                            });
                        });
                        
                        // Update the total progress bar
        myDropzone.on("totaluploadprogress", function (progress) {
                            const progressBars = dropzone.querySelectorAll('.progress-bar');
                            progressBars.forEach(progressBar => {
                                progressBar.style.width = progress + "%";
                            });
                        });
                        
        myDropzone.on("sending", function (file) {
                            // Show the total progress bar when upload starts
                            const progressBars = dropzone.querySelectorAll('.progress-bar');
                            progressBars.forEach(progressBar => {
                                progressBar.style.opacity = "1";
                            });
                        });
                        
                        // Hide the total progress bar when nothing"s uploading anymore
        myDropzone.on("complete", function (progress) {
                            const progressBars = dropzone.querySelectorAll('.dz-complete');
                        
                            setTimeout(function () {
                                progressBars.forEach(progressBar => {
                                    progressBar.querySelector('.progress-bar').style.opacity = "0";
                                    progressBar.querySelector('.progress').style.opacity = "0";
                                });
                            }, 300);
                        });

    }

    const initLocationDropdown = () => {
        var selLoc = $("#kt_feedback_location");
        var other_location = document.querySelector('#other_location');

        selLoc.select2({
            placeholder: "Select a location",
            minimumResultsForSearch: Infinity
        });

        selLoc.on('select2:select', function (e) {
        var sel = e.params.data;

        if(sel.text === "Other"){
            other_location.type = 'text';
            other_location.required = true;
        }
        else{
            other_location.type = 'hidden';
            other_location.required = false;
        }

        });
    }

    const initTypeSelection = () => {
        var type = document.querySelectorAll('[name="feedback_type_id"]');
        var input_group = document.querySelector('#feedback_category');        
        var selected = document.querySelector('input[name="feedback_type_id"]:checked');

        if (selected?.title == 'undefined') {
            showHide(selected.title);
        }

        function elementToggle(event) {
            showHide(event.target.title);
        }

        function showHide(selection) {
            if (selection == "Suggestion") {
                input_group.classList.add("d-none");
                input_group.classList.remove("d-block");
            }
            else {
                input_group.classList.remove("d-none");
                input_group.classList.add("d-block");
            }
        }

        type.forEach((input) => {
            input.addEventListener('change', elementToggle);
        });
    }

    const initCategoryOther = () => {
        var type = document.querySelectorAll('[name="category_id[]"]');
        var other_category = document.querySelector('#other_category');

        function elementChecked(event) {
            var selected =  event.target.title;
                if(selected === "Other"){
                    if(event.target.checked){
                        other_category.type = 'text';
                        other_category.required = true;
                    }          
                    else{
                        other_category.type = 'hidden';
                        other_category.required = false;
                    }
                }
            }
            
        

        type.forEach((input) => {
            input.addEventListener('change', elementChecked);
        });
    }

    // var initFileRepeater = () => {
    //     $('#multi_file_uploader').repeater({
    //         initEmpty: false,
        
    //         defaultValues: {
    //             'text-input': ''
    //         },
        
    //         show: function () {
    //             if( $("div[data-repeater-item]").length <= 5 ){
    //                 $(this).slideDown();
    //             } else {
    //                 $(this).remove();
    //             }
    //         },
        
    //         hide: function (deleteElement) {
    //             $(this).slideUp(deleteElement);
    //         }
    //     });
    // }

    // Public methods
    return {
        init: function () {  
            window.addEventListener("beforeunload", handleBeforeUnload);            
            form = document.querySelector('#kt_feedback_form');
            submitButton = document.querySelector('#kt_feedback_submit');         
            initLocationDropdown();
            initTypeSelection();
            initCategoryOther();
            initDropzone();
            // initFileRepeater();
            handleForm();            
        }
    }
}();

// On document ready
KTUtil.onDOMContentLoaded(function () {
    KTFeedbackFormQr.init();
});